exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mytable{font-family:arial,sans-serif;border-collapse:collapse;width:100%}#mytable td,#mytable th{border:1px solid #ddd;text-align:left;padding:8px}#mytable tr:nth-child(2n){background-color:#ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-178830dc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/administration/salary_entry/salary_entry_form.vue
// module id = 1315
// module chunks = 3